class exports.Add_Row_Spacing_Dialog extends DialogHandler

    init: () ->
        @classes = 'smaller_dialog'
        @layoutUrl = 'backend/grower/machinery/load-layout-add-row-spacing'

        @saveUrl = 'backend/grower/machinery/add-row-spacing'
        @refreshNavHandler = false

        @createDialog()


    afterLoadLayout: () ->
        @openDialog()


    submitAction: () ->
        @save('Saving...')
